namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmFunkcniMisto extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmFunkcniMistoReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmFunkcniMistoObj & GContent;
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;
        private adxCheckIcoNad: number;
        private gin_iszr_funrol: number;
        private agendyFunkce: Gordic.Adm.Interface.GSzrvaroExtDto[];
        private agendoveRoleFunkce: Gordic.Adm.Interface.GSzrvfarExtDto[];

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmFunkcniMistoObj());
            this.detailObj.createBase({
                contentName: "detailAdmFunkcniMisto",
                contentCaption: "jres:32131054",
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: true,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            this.detailObj.adxCheckIcoNad = this.adxCheckIcoNad;
            const tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false) {
                tabs.push(this.detailObj.createPrirazeneAgendyRoleTab());
                tabs.push(this.detailObj.createZastupyTab());
                tabs.push(this.detailObj.createInstanceTab());
                tabs.push(this.detailObj.createKonfiguracniSkupinyTab())
                tabs.push(this.detailObj.createParametryTab());
                tabs.push(this.detailObj.createUcetniStrediskaTab());
                tabs.push(this.detailObj.createUctarnyTab());
                tabs.push(this.detailObj.getAuditPristupuTab());
            }
            const groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false) {
                groups.push(this.detailObj.createPrirazeneAgendyRoleGroup());
                groups.push(this.detailObj.createZastupyGroup());
                groups.push(this.detailObj.createInstanceGroup());
                groups.push(this.detailObj.createKonfiguracniSkupinyGroup());
                groups.push(this.detailObj.createParametryGroup());
                groups.push(this.detailObj.createUcetniStrediskaGroup());
                groups.push(this.detailObj.createUctarnyGroup());
                groups.push(this.detailObj.getAuditPristupuGroup());
            }
            builder.withComponent<this>("DetailAdmFunkcniMisto", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmFunkcniMistoObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmFunkcniMistoReadDto> {
        isPovolDeleteUserSettings: boolean;
        isPovolenaEvidenceOP: boolean;
        adxCheckIcoNad: number;
        prirazeneRoleAgendyIszr: GPrirazeneRoleAgendyISZR;
        agendyFunkce: Gordic.Adm.Interface.GSzrvaroExtDto[];
        agendoveRoleFunkce: Gordic.Adm.Interface.GSzrvfarExtDto[];
        newRecord: boolean;
        gin_iszr_funrol: number;
        isPovoleneSpisUzly: boolean;
        currentIxsSu: string;

        create() {
            if (this.options.newRecord == false) {
                this.prirazeneRoleAgendyIszr = new GPrirazeneRoleAgendyISZR({
                    cnt: this.cnt,
                    ginIszrFunrol: this.gin_iszr_funrol,
                    isPovolenaEvidenceOP: this.isPovolenaEvidenceOP,
                    permission: {
                        edit: this.data.Permissions?.CanWrite.value == true,
                        create: this.data.Permissions?.CanCreate.value == true
                    },
                    agendy: this.agendyFunkce.map(agendaFunkce => ({
                        agenda: agendaFunkce.agenda,
                        nazev: agendaFunkce.agenda_txt,
                        priz_aisc: agendaFunkce.s_prist_aisc,
                        priz_isep: agendaFunkce.s_prist_isep,
                        priz_aiseo: agendaFunkce.s_prist_aiseo,
                        priz_aiseop: agendaFunkce.s_prist_aiseop, 
                        pocet_role: agendaFunkce.pocet_role
                    })),
                    role: this.agendoveRoleFunkce.map(agendovaRole => ({
                        agenda: agendovaRole.agenda,
                        role: agendovaRole.agendova_role
                    }))
                })
            }
        }

        textPopis(): string | undefined | null {
            return `${this.data.nazev}`
        }

        setSxsDetail(): string {
            return `${this.data.ixs_fun}`
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmFunkcniMistoSaveDto, close: boolean) {
            if (this.newRecord == false) {
                data.agendy = this.prirazeneRoleAgendyIszr.getPrirazeneAgendy().map(ag => ({
                    agenda: ag.agenda,
                    aktivita: 100,
                    ixs_fun: this.data.ixs_fun,
                    s_prist_aisc: ag.priz_aisc,
                    s_prist_aiseo: ag.priz_aiseo,
                    s_prist_isep: ag.priz_isep,
                    s_prist_aiseop: ag.priz_aiseop
                }))
                data.agendove_role = this.prirazeneRoleAgendyIszr.getPrirazeneRole().map(agr => ({
                    agenda: agr.agenda,
                    agendova_role: agr.role,
                    aktivita: 100,
                    ixs_fun: this.data.ixs_fun
                }))
            }
            this.saveDataSpecial(data, close);
        }

        private saveDataSpecial(data, close) {
            (this.cnt.isl.AdmFunkcniMisto.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderGinsfun");
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    });
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.showBaseError();
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            this.openDetailOrModalWindow("Gordic.Adm.WebControls.DetailAdmFunkcniMisto", filterObj, dataObj);
        }

        updateGrid(filter: any, grid: any): JQueryPromise<Gordic.Data.View<Gordic.Data.UnpackRow<any>>> {
            return this.cnt.isl.AdmFunkcniMisto.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.nazev) ? this.data.nazev : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                {
                    caption: "jres:33000138",
                    favorite: true,
                    icon: "fa-link",
                    visible: this.options.newRecord == false,
                    children: [
                        { action: this.cnt.actions.actOpenSeznamZastup },
                        { action: this.cnt.actions.actOpenSeznamAdmFunkcniMistoInstance },
                        { action: this.cnt.actions.actSeznamAdmFunkcniMistoKonfiguracniSkupina },
                        { action: this.cnt.actions.actOpenSeznamParametry },
                        { action: this.cnt.actions.actOpenSkupinyFunkciClen },
                        { action: this.cnt.actions.actOpenSkupinyFunkciOpravneni },
                        { action: this.cnt.actions.actOpenSeznamFunkceSchvalovaciRoleEpk },
                        { action: this.cnt.actions.actOpenSeznamFunkceSchvalovaciSablonyEpk },
                        { type: "separator" },
                        { action: this.cnt.actions.actOpenStrediskaUctovani },
                        { action: this.cnt.actions.actOpenUctarny }
                    ]
                },
                "actDeleteUserSettinsNew",
                "actOpenDialogDeleteEkoinit",
                //{
                //    caption: "jres:33000783",
                //    favorite: true,
                //    icon: "gi-settings",
                //    visible: this.options.newRecord == false,
                //    children: [
                //        //{ action: this.cnt.actions.actDeleteUserSettins }
                //        { action: this.cnt.actions.actDeleteUserSettinsNew },
                //        { action: this.cnt.actions.actOpenDialogDeleteEkoinit }
                //    ]
                //},
                this.createShareActions(),
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actSeznamAdmFunkcniMistoKonfiguracniSkupina: {
                    icon: "fa-link",
                    caption: "jres:33000015", //RC 33000015 : Konfigurační skupiny
                    visible: this.options.newRecord == false,
                    run: () => {
                        this.openSeznamAdmFunkcniMistoKonfiguracniSkupina();
                    }
                },
                actOpenSeznamZastup: {
                    icon: "fa-link",
                    caption: "jres:32131159", //RC 32131159 : Zástupy
                    visible: this.options.newRecord == false,
                    run: () => {
                        this.openSeznamZastup();
                    }
                },
                actOpenSeznamParametry: {
                    icon: "fa-link",
                    caption: "jres:33000853",
                    visible: this.options.newRecord == false,
                    run: () => {
                        this.openParametrySeznam();
                    }
                },
                //actDeleteUserSettins: {
                //    icon: "gi-settings",
                //    caption: "jres:33000062", //RC 33000062 : Smazat uživatelské nastavení aplikací
                //    visible: this.options.newRecord == false,
                //    run: () => {
                //        this.deleteuserSettings();
                //    }
                //},
                actDeleteUserSettinsNew: {
                    icon: "gi-settings",
                    caption: "jres:33000873", //RC 33000873 : Smazat uživ. nastavení přiřazené osobě
                    tooletip: "jres:33000874", //RC 33000874 : Smaže uživatelské nastavení přiřazené osobě 
                    visible: this.options.newRecord == false,
                    enabled: this.isPovolDeleteUserSettings,
                    run: () => {
                        this.deleteuserSettingsNew();
                    }
                },
                actOpenDialogDeleteEkoinit: {
                    icon: "gi-settings",
                    caption: "jres:33000884", //RC 33000884 : Smazat ekoinicializaci funkčního místa
                    tooltip: "jres:33000885", //RC 33000885 : Smaže ekoinicializaci funkčního místa, volitelně lze zadat i fáze, pro které lze ekoinicializaci smazat.
                    visible: this.options.newRecord == false,
                    enabled: this.savePermissionObj.permission,
                    run: () => {
                        this.dialogDeleteEkoinit();
                    }
                },
                actOpenSeznamAdmFunkcniMistoInstance: {
                    icon: "fa-link",
                    caption: "jres:33000607", //RC 33000607 : Instance funkčního místa
                    tooltip: "jres:33000608", //RC 33000608 : Umožňuje navázat instance přímo na funkční místo
                    visible: this.options.newRecord == false,
                    run: () => {
                        this.openSeznamAdmFunkcniMistoInstance();
                    }
                },
                actOpenStrediskaUctovani: {
                    icon: "fa-link",
                    caption: "jres:33000857",
                    visible: this.options.newRecord == false,
                    run: () => {
                        this.openStrediskaUctovani();
                    }
                },
                actOpenUctarny: {
                    icon: "fa-link",
                    caption: "jres:33000858",
                    visible: this.options.newRecord == false,
                    run: () => {
                        this.openUctarny();
                    }
                },
                actOpenSkupinyFunkciClen: {
                    icon: "fa-link",
                    caption: "jres:33000893", //RC 33000893 : Skupiny funkcí 
                    visible: this.options.newRecord == false,
                    run: () => {
                        this.openSeznamSkupinyFunkciClen();
                    }
                },
                actOpenSkupinyFunkciOpravneni: {
                    icon: "fa-link",
                    caption: "jres:33000894", //RC 33000894 : Oprávnění ke skupinám funkcí
                    visible: this.options.newRecord == false,
                    run: () => {
                        this.openSkupinaFunkciOpravneni();
                    }
                },
                actOpenSeznamFunkceSchvalovaciRoleEpk: {
                    icon: "fa-link",
                    caption: "jres:33000898",
                    visible: this.options.newRecord == false,
                    run: () => {
                        this.openSeznamFunkceSchvalovaciRoleEpk();
                    }
                },
                actOpenSeznamFunkceSchvalovaciSablonyEpk: {
                    icon: "fa-link",
                    caption: "jres:33000902",
                    visible: this.options.newRecord == false,
                    run: () => {
                        this.openSeznamFunkceSchvalovaciSablonyEpk();
                    }
                },
                actOpenDetailOsoba: {
                    icon: "gi-detail",
                    caption: "jres:29931148",
                    enabled: false,
                    captionVisible: "never",
                    run: () => {
                        this.openDetailOsoba()
                    }
                },
                actOpenDetailOrganizacniJednotka: {
                    icon: "gi-detail",
                    caption: "jres:29802620",
                    enabled: false,
                    captionVisible: "never",
                    run: () => {
                        this.openDetailOrganizacniJednotka()
                    }
                },
                actOpenDetailAdmSpisovyUzel: {
                    icon: "gi-detail",
                    caption: "jres:29931149",
                    enabled: false,
                    captionVisible: "never",
                    run: () => {
                        this.openDetailSpisovyUzel();
                    }
                },
                actOpenNadrizenaFunkce: {
                    icon: "gi-detail",
                    caption: "jres:33000856", //RC 33000856 : Nadřízené funkční místo
                    enabled: false,
                    captionVisible: "never",
                    run: () => {
                        this.openNadrizenaFunkce();
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {
            if (this.options.newRecord == false) {
                this.prirazeneRoleAgendyIszr.changeEdit(editMode);
            }
            this.cnt.findFields("spisove_uzly").gfield(editMode ? "enable" : "disable");
        }

        createForm() {
            this.form.form.layoutDescriptor = "L2M2S1";
            this.MakeSection("");
            this.MakeSelectField("ico", Gordic.Prefabs.Select.ginsico(), { model: "model.ico=value.ico" });
            this.MakeField("ixs_fun");
            this.MakeField("zkratka");
            this.MakeField("nazev");
            this.MakeField("ofic_nazev");
            this.MakeField("poznamka");
            this.MakeField("fc");
            this.MakeField("tel");
            this.MakeField("mail");
            this.MakeField("fax");
            this.MakeField("url");
            
            // GetDatabaseParameter("adx_checkiconad", 0) == 1
            if (this.adxCheckIcoNad === 1) {
                this.MakeSelectField("ixs_nad", Gordic.Prefabs.Select.ginsfun(), {
                    model: "model.ico=>value.ico,model.ixs_nad=value.ixs_fun",
                    serverFilters: {
                        aktivita: null,
                        ico: new Gordic.Forms.Dependency("ico", "ico", true, false, this.cnt.element)
                    },
                    dropdown: false,
                    change: (ev, ctx) => {
                        this.cnt.actions.actOpenNadrizenaFunkce?.update({ enabled: ctx.value != null })
                    },
                    verticalButtons: false,
                    buttons: [
                        { action: this.cnt.actions.actOpenNadrizenaFunkce }
                    ]
                });
            } else {
                this.MakeSelectField("ixs_nad", Gordic.Prefabs.Select.ginsfun(), {
                    model: "model.ixs_nad=value.ixs_fun",
                    serverFilters: {
                        aktivita: null,
                    },
                    dropdown: false,
                    change: (ev, ctx) => {
                        this.cnt.actions.actOpenNadrizenaFunkce?.update({ enabled: ctx.value != null })
                    },
                    verticalButtons: false,
                    buttons: [
                        { action: this.cnt.actions.actOpenNadrizenaFunkce }
                    ]
                });
            }
            this.MakeSelectField("ixs_orj", Gordic.Prefabs.Select.ginsorj(), {
                model: "model.ico=>value.ico,model.ixs_orj=value.ixs_orj",
                serverFilters: {
                    aktivita: null,
                    ico: new Gordic.Forms.Dependency("ico", "ico", true, false, this.cnt.element)
                },
                dropdown: false,
                change: (ev, ctx) => {
                    this.cnt.actions.actOpenDetailOrganizacniJednotka?.update({ enabled: ctx.value != null })
                },
                verticalButtons: false,
                buttons: [
                    { action: this.cnt.actions.actOpenDetailOrganizacniJednotka }
                ]
             });
            this.MakeSelectField("ixs_su", Gordic.Prefabs.Select.ginspod(), {
                model: "model.ico=>value.ico,model.ixs_su=value.ixs_su",
                serverFilters: {
                    aktivita: null,
                    ico: new Gordic.Forms.Dependency("ico", "ico", true, false, this.cnt.element)
                },
                dropdown: false,
                change: (ev, ctx) => {
                    this.cnt.findFields("ixs_su").gfield("resetErrors", "change-spis-uzel");
                    this.cnt.actions.actOpenDetailAdmSpisovyUzel?.update({ enabled: ctx.value != null })
                    if (this.options.newRecord == false) {
                        if (ctx.value) {
                            if (!Array.isArray(ctx.value)) {
                                if (ctx.value.ixs_su != this.data.ixs_su) {
                                    this.cnt.findFields("ixs_su").gfield("setError", { //RC 33000959 : Při změně spisového uzlu dojede i k převodu dokumentů vázaných na funkční místo. Změnu pečlivě zvažte.
                                        message: "jres:33000959",
                                        errorType: "warning",
                                        stopping: false,
                                        group: "change-spis-uzel"
                                    })
                                }
                            }
                        }
                    }
                    if (this.isPovoleneSpisUzly == true && ctx.value) {
                        if (!Array.isArray(ctx.value)) {
                            let data = this.cnt.findFields("spisove_uzly").gfield("getValue");
                            if (data.length > 0) {
                                let index = data.findIndex(item => item.ixs_su == this.currentIxsSu);
                                if (index != -1)
                                    data.splice(index, 1);
                            }
                            this.currentIxsSu = ctx.value.ixs_su ?? "";
                            let index = data.findIndex(item => item.ixs_su == this.currentIxsSu)
                            if (index == -1)
                                data.push({ ixs_su: this.currentIxsSu })
                            this.cnt.findFields("spisove_uzly").gfield("setValue", data.map(item => ({ ixs_su: item.ixs_su })), false);
                        }
                    } 
                },
                verticalButtons: false,
                buttons: [
                    { action: this.cnt.actions.actOpenDetailAdmSpisovyUzel }
                ]
            });
            this.MakeSelectField("ixs_ref", Gordic.Prefabs.Select.ginsref(), {
                model: "model.ico=>value.ico,model.ixs_ref=value.ixs_ref",
                serverFilters: {
                    aktivita: null,
                    IcoOrSharedIco: new Gordic.Forms.Dependency("ico", "ico", true, false, this.cnt.element)
                },
                dropdown: false,
                change: (ev, ctx) => {
                    this.cnt.actions.actOpenDetailOsoba?.update({ enabled: ctx.value != null })
                },
                verticalButtons: false,
                buttons: [
                    { action: this.cnt.actions.actOpenDetailOsoba }
                ]
            });
            this.MakeSection("");
            this.MakeSelectField("priz_servis", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_servis=value.priz_an" });
            this.MakeSelectField("pri_fun", Gordic.Prefabs.Select.gincprf(), { model: "model.pri_fun=value.pri_fun" } );
            this.MakeSelectField("priorita_max", Gordic.Prefabs.Select.gincpri(), { model: "model.priorita_max=value.priorita_max" } );
            this.MakeSelectField("status_fun", Gordic.Prefabs.Select.gincstf(), { model: "model.status_fun=value.status_fun" } );
            this.MakeSelectField("uroven_fun", Gordic.Prefabs.Select.gincufu(), { model: "model.uroven_fun=value.uroven_fun" });
            if (this.isPovoleneSpisUzly == true) {
                this.form.addRow("jres:33000091").addField("gselectbox", Gordic.Prefabs.Select.admGinspod({
                    gridFormat: new Gordic.Data.GridFormat()
                        .addTextColumn({
                            name: "nazev",
                            caption: "jres:32131029"
                        })
                        .addTextColumn({
                            name: "zkratka",
                            caption: "jres:32131028"
                        })
                        .addTextColumn({
                            name: "lic_adr",
                            caption: "jres:29930142"
                        })
                        .addTextColumn({
                            name: "ico",
                            caption: "jres:32131151"
                        })
                }), {
                    name: "spisove_uzly",
                    multi: true,
                    disabled: true,
                    itemDeletable: (row) => {
                        return row?.ixs_su != this.currentIxsSu;
                    },
                    itemTemplate: (row) => {
                        var prirazeni = (row?.ixs_su == this.currentIxsSu) ? "jres:33001028" : "jres:33001029"; //RC 33001029 : Vedlejší spisový uzel
                        return `<b>${row?.nazev}</b> | jres:29930142: ${row?.lic_adr}<br /><i>${prirazeni}</i>`;
                    },
                    graphicInput: "oninput",
                    itemWidth: "",
                    model: function (op, dto, opt) {
                        switch (op) {
                            case "apply":
                                if (dto.spisove_uzly != null )
                                    $(this).gfield("setValue", dto.spisove_uzly.map(item => ({ ixs_su: item.ixs_su })), false);
                                break;
                            case "collect":
                                var data = $(this).gfield("getValue");
                                dto.spisove_uzly = [];
                                data.forEach((item) => {
                                    dto.spisove_uzly.push({ ixs_su: item.ixs_su, aktivita: 100 })
                                })
                                break;
                        }
                    }
                })
            }
            this.MakeField("dat_od");
            this.MakeField("dat_do", { validators: [ this.checkValidatorOdDo() ] });
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        createPrirazeneAgendyRoleTab() {
            return this.prirazeneRoleAgendyIszr.createTab();
        }

        createZastupyTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-zastupy",
                    title: "jres:32131159",
                    opened: true,
                    locked: true,
                    group: { id: "_tab-zastupy" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamZastup",
                    serverParams: {
                        ID: "SeznamZastup",
                        ixs_fun: this.data.ixs_fun,
                        tabOpen: true
                    }
                }
            }
        }

        createParametryTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-parametry",
                    title: "jres:33000853", //RC 33000853 : Parametry funkčního místa
                    opened: true,
                    locked: true,
                    group: { id: "_tab-parametry" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmParametrGlobal",
                    serverParams: {
                        ID: "SeznamAdmParametrGlobal",
                        ixs_fun: this.data.ixs_fun,
                        uroven_cfg: 60,
                        tabOpen: true
                    }
                }
            }
        }

        createInstanceTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-instance",
                    title: "jres:33000607",
                    opened: true,
                    locked: true,
                    group: { id: "_tab-instance" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmKonfiguracniSkupinaProgramovaInstance",
                    serverParams: {
                        ID: "SeznamAdmKonfiguracniSkupinaProgramovaInstance",
                        ixs_fun: this.data.ixs_fun,
                        typ_usr: 10,
                        tabOpen: true
                    }
                }
            }
        }

        createKonfiguracniSkupinyTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-konfiguracni-skupiny",
                    title: "jres:33000015",
                    opened: true,
                    locked: true,
                    group: { id: "_tab-konfiguracni-skupiny" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmFunkcniMistoKonfiguracniSkupina",
                    serverParams: {
                        ID: "SeznamAdmFunkcniMistoKonfiguracniSkupina",
                        ixs_fun: this.data.ixs_fun,
                        tabOpen: true
                    }

                }
            }
        }

        createUcetniStrediskaTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-ucetni-strediska",
                    title: "jres:33000862", //RC 33000862 : Střediska účtování fun. místa
                    opened: true,
                    locked: true,
                    group: { id: "_tab-ucetni-strediska" }
                },
                contentParams: {
                    className: "Gordic.Ade.WebControls.SeznamAdeUcetniStrediskoFunkcniMisto",
                    serverParams: {
                        ID: "SeznamAdeUcetniStrediskoFunkcniMisto",
                        ixs_fun: this.data.ixs_fun,
                        ico: this.data.ico,
                        tabOpen: true
                    }
                }
            }
        }

        createUctarnyTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-uctarny",
                    title: "jres:33000863", //RC 33000863 : Účtárny fun. místa
                    opened: true,
                    locked: true,
                    group: { id: "_tab-uctarny" }
                },
                contentParams: {
                    className: "Gordic.Ade.WebControls.SeznamAdeUctarnaFunkcniMisto",
                    serverParams: {
                        ID: "SeznamAdeUctarnaFunkcniMisto",
                        ixs_fun: this.data.ixs_fun,
                        ico: this.data.ico,
                        tabOpen: true
                    }
                }
            }
        }

        //createSpisoveUzlyTab(): Gordic.Gin.DetailBuilder.TabParamsId {
        //    return {
        //        tabParams: {
        //            id: "tab-spisove-uzly",
        //            title: "jres:33000091",
        //            opened: true,
        //            locked: true,
        //            group: { id: "_tab-spisove-uzly" }
        //        },
        //        contentParams: {
        //            className: "Gordic.Adm.WebControls.SeznamAdmPovolenySpisovyUzelFunkce",
        //            serverParams: {
        //                ID: "SeznamAdmPovolenySpisovyUzelFunkce",
        //                ixs_fun: this.data.ixs_fun,
        //                tabOpen: true
        //            }
        //        }
        //    }
        //}

        createPrirazeneAgendyRoleGroup() {
            return this.prirazeneRoleAgendyIszr.createGroup();
        }

        createZastupyGroup(): IGTabGroupOptions {
            return { id: "_tab-zastupy", caption: "jres:32131159" }
        }

        createParametryGroup(): IGTabGroupOptions {
            return { id: "_tab-parametry", caption: "jres:33000853" }
        }

        createInstanceGroup(): IGTabGroupOptions {
            return { id: "_tab-instance", caption: "jres:33000607" }
        }

        createKonfiguracniSkupinyGroup(): IGTabGroupOptions {
            return { id: "_tab-konfiguracni-skupiny", caption: "jres:33000015" }
        }

        createUcetniStrediskaGroup(): IGTabGroupOptions {
            return { id: "_tab-ucetni-strediska", caption: "jres:33000862" }
        }

        createUctarnyGroup(): IGTabGroupOptions {
            return { id: "_tab-uctarny", caption: "jres:33000863" }
        }

        //createSpisoveUzlyGroup(): IGTabGroupOptions {
        //    return { id: "_tab-spisove-uzly", caption: "jres:33000091" }
        //}

        private openSeznamAdmFunkcniMistoKonfiguracniSkupina() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmFunkcniMistoKonfiguracniSkupina", { ixs_fun: this.data.ixs_fun })
        }

        private openSeznamZastup() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamZastup", { ixs_fun: this.data.ixs_fun })
        }

        private openSeznamAdmFunkcniMistoInstance() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmKonfiguracniSkupinaProgramovaInstance", { ixs_fun: this.data.ixs_fun, typ_usr: 10 })
        }

        private openParametrySeznam() {
            this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmParametrGlobal"], { ixs_fun: this.data.ixs_fun, uroven_cfg: 60 })
        }

        private openStrediskaUctovani() {
            this.cnt.navigate(["Gordic.Ade.WebControls.SeznamAdeUcetniStrediskoFunkcniMisto"], { ixs_fun: this.data.ixs_fun, ico: this.data.ico })
        }

        private openUctarny() {
            this.cnt.navigate(["Gordic.Ade.WebControls.SeznamAdeUctarnaFunkcniMisto"], { ixs_fun: this.data.ixs_fun, ico: this.data.ico })
        }

        private deleteuserSettings() {
            this.cnt.beginOperation();
            const req: Gordic.AdmIsl.Interface.GAdmFunkcniMistoDto[] = [{ ixs_fun: this.data.ixs_fun }]
            this.cnt.isl.AdmFunkcniMisto.deleteAppUserSettings({ rq: req }).getData().then(() => {
                this.showSuccessSave(true, "jres:33000060");
            }).catch(() => {
                this.showBaseError("jres:33000061");
            }).always(() => {
                this.cnt.endOperation();
            });
        }

        private deleteuserSettingsNew() {
            if (this.data.ixs_ref) {
                this.cnt.dialogs.showModalWindow([Gordic.Adm.WebControls.DialogDeleteUserSettings, {
                    funkcniMista: [this.data.ixs_fun],
                    rezimDialog: Gordic.Adm.WebControls.RezimDialog.fukncniMisto,
                    openFromDetail: true,
                }], {}, {
                    width: 600,
                    height: 400
                });
            }
        }

        private dialogDeleteEkoinit() {
            this.cnt.dialogs.showModalWindow([Gordic.Adm.WebControls.DialogAdmFunkcniMistoDeleteEkonini, {
                funkcniMista: [this.data.ixs_fun],
                openFromDetail: true
            }], {}, {
                width: 600,
                height: 400
            });
        }

        private openDetailOsoba() {
            const osoba = this.cnt.findFields("ixs_ref").gfield("getValue");
            if (osoba != null)
                this.cnt.navigate(["Gordic.Adm.WebControls.DetailAdmOsoba"], { ID: "DetailAdmOsoba", newRecord: false, ixs_ref: osoba.ixs_ref })
        }

        private openDetailOrganizacniJednotka() {
            const orgJed = this.cnt.findFields("ixs_orj").gfield("getValue");
            if (orgJed != null)
                this.cnt.navigate(["Gordic.Adm.WebControls.DetailOrganizacniJednotkaNew"], { ID: "DetailOrganizacniJednotkaNew", newRecord: false, ixs_orj: orgJed.ixs_orj })
        }

        private openDetailSpisovyUzel() {
            const spisUzel = this.cnt.findFields("ixs_su").gfield("getValue");
            if (spisUzel != null)
                this.cnt.navigate(["Gordic.Adm.WebControls.DetailAdmSpisovyUzel"], { ID: "DetailAdmSpisovyUzel", newRecord: false, ixs_su: spisUzel.ixs_su })
        }

        private openNadrizenaFunkce() {
            const nadrizenaFunkce = this.cnt.findFields("ixs_nad").gfield("getValue");
            if (nadrizenaFunkce != null)
                this.cnt.navigate(["Gordic.Adm.WebControls.DetailAdmFunkcniMisto"], { ID: "DetailAdmFunkcniMisto", newRecord: false, ixs_fun: nadrizenaFunkce.ixs_fun })
        }

        private openSeznamSkupinyFunkciClen() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamSkupinaFunkciClen", { ixs_fun: this.data.ixs_fun })
        }

        private openSkupinaFunkciOpravneni() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamSkupinaFunkciOpravneni", { ixs_fun: this.data.ixs_fun })
        }

        private openSeznamFunkceSchvalovaciRoleEpk() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamFunkceSchvalovaciRoleEpk", { ixs_fun: this.data.ixs_fun })
        }

        private openSeznamFunkceSchvalovaciSablonyEpk() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamFunkceSchvalovaciSablonyEpk", { ixs_fun: this.data.ixs_fun })
        }
    }
}